import { ChevronDownIcon, ChevronUpIcon, PencilIcon } from "@heroicons/react/24/outline";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface ShowEditDetailsButtonProps {
    editing: boolean;
    mode: "edit" | "view";
    onToggle: () => void;
}

const ShowDetailsLabel: React.FC<{ mode: ShowEditDetailsButtonProps["mode"] }> = ({
    mode,
}) =>
    mode === "edit" ? (
        <>
            <PencilIcon aria-hidden="true" className="h-3.5 w-3.5" />
            <span>Show/Edit details</span>
        </>
    ) : (
        <>
            <ChevronDownIcon aria-hidden="true" className="h-3.5 w-3.5" />
            <span>Show details</span>
        </>
    );

export const ShowEditDetailsButton: React.FC<ShowEditDetailsButtonProps> = props => {
    const { editing, mode, onToggle } = props;

    return (
        <SecondaryCompactButton
            onClick={onToggle}
            aria-expanded={editing}
            className="flex-shrink-0 items-center space-x-1">
            {editing ? (
                <>
                    <ChevronUpIcon aria-hidden="true" className="h-3.5 w-3.5" />
                    <span>Hide details</span>
                </>
            ) : (
                <ShowDetailsLabel mode={mode} />
            )}
        </SecondaryCompactButton>
    );
};
